/**
 * Class for obfuscate links.
 */
export default class ObfuscateLinks {
  constructor() {
    this.create();
  }

  /*
   * Create links
   */
  create() {
    const selectedClass = 'js-linkObfuscate';

    document.addEventListener('click', (event) => {
      if (event.target instanceof HTMLElement) {
        const currentElement: HTMLElement = event.target;

        // Add slide event
        if (
          currentElement.classList.contains(selectedClass) ||
          currentElement.closest(`.${selectedClass}`)
        ) {
          let linkObfuscate: HTMLElement = currentElement;
          if (!currentElement.hasAttribute('data-href')) {
            linkObfuscate = currentElement.closest(`.${selectedClass}`);
          }
          // href
          if (linkObfuscate.hasAttribute('data-href')) {
            this.linkAction(linkObfuscate);
          }
        }
      }
    });
  }

  /*
   * Obfuscate link
   */
  str_rot13(str: string) {
    return `${str}`.replace(/[a-z]/gi, (s) => {
      return String.fromCharCode(
        s.charCodeAt(0) + (s.toLowerCase() < 'n' ? 13 : -13)
      );
    });
  }

  /*
   * Redirect to link
   */
  linkAction(link: HTMLElement) {
    let targetLink = '_self';

    if (link.hasAttribute('target')) {
      targetLink = link.getAttribute('target');
    }

    window.open(this.str_rot13(link.dataset.href), targetLink);
  }
}
